import * as _ from 'lodash'
import {ProductConditionTypeBO} from "./ProductConditionTypeBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {WB_ProductConditionTypeRow} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Product_Condition_Type} from "../PA.Core/PAdbSchema";


export class ProductConditionTypeBOValidations {


    static async ValidateFields(aBO: ProductConditionTypeBO): Promise<void> {

        let dbContext = new PAdbContext({})


        // Validate Condition Type Name
        if (_.isEmpty(aBO.WB_ProductConditionType.cif.CONDITION_TYPE_NAME)) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'EmptyName',
                    type: MessageType.Error,
                    title: "Condition Type Name cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        } else {
            aBO.ValidateMessageProvider.removeMessage('EmptyName')
        }

        if (_.isEmpty(aBO.WB_ProductConditionType.cif.CONDITION_TYPE)) {
            aBO.ValidateMessageProvider.addMessage(
                {
                    code: 'EmptyID',
                    type: MessageType.Error,
                    title: "Condition Type ID cannot be empty",
                    description: "",
                    subtitle: "",
                    count: 0
                })
        } else {
            aBO.ValidateMessageProvider.removeMessage('EmptyID')
        }


        // Condition Types are considered duplicates only within the same Master Data Set
        let productConditionTypeRows: WB_ProductConditionTypeRow[] = await dbContext.findAll(esWB_Product_Condition_Type,
            {where: {DELETED_IND: {neq: '1'},
                    PRD_CNDM_ID: {neq: aBO.WB_ProductConditionType.cif.PRD_CNDM_ID},
                    WB_MDSET_ID: aBO.WB_ProductConditionType.cif.WB_MDSET_ID,
                    CONDITION_TYPE: aBO.WB_ProductConditionType.cif.CONDITION_TYPE}})



        if (!_.isEmpty(productConditionTypeRows)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "duplicateID", type: MessageType.Error,
                title: 'Existing Condition Type with the same ID: ' +
                    '\nCondition Type: ' + _.map(productConditionTypeRows, (a) => `${a.cif.CONDITION_TYPE_NAME} (${a.cif.CONDITION_TYPE})`).join(","),
                description: "",
                subtitle: "",
                count: 0
            })
        } else {
            aBO.ValidateMessageProvider.removeMessage("duplicateID")
        }



    }
}
